import Checkbox from './Checkbox';
import Group from './Group';
Checkbox.Group = Group;
export default Checkbox;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_antd@4.1.3@antd/es/checkbox/index.js
// module id = 2489
// module chunks = 0